import React from "react";
import Cover from "@img/mitra-kerjasama/cover.png";
import { useEffect, useState } from "react";
import FloatingMenu from "../components/FloatingMenu";
import MitraForm from "../components/MitraForm";

const MitraList = () => {
  const [mitraData, setMitraData] = useState([]);

  useEffect(() => {
    fetchMitraData();
  }, []);

  const fetchMitraData = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/cooperation-partners"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data mitra");
      }
      const data = await response.json();
      setMitraData(Array.isArray(data.data) ? data.data : []);
    } catch (error) {
      setMitraData([]);
    }
  };
  
  return (
    <>
      <div className="flex flex-col justify-center text-white leading-[100%] mt-24">
        <div className="flex overflow-hidden relative flex-col justify-center w-full max-md:w-full max-sm:h-[150px] max-sm:w-full">
          <img
            loading="lazy"
            src={Cover}
            className="object-cover w-full h-full"
            alt="header"
          />
        </div>
      </div>
      <div className="flex flex-col px-8 py-2 lg:py-16 max-md:px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="mt-7 text-2xl lg:text-3xl font-bold leading-9 text-gray-800">
            Manfaat Kemitraan dengan OKOCE
          </div>
          <div
            className="mt-2 lg:mt-4 text-base lg:text-lg leading-7 text-justify text-gray-600"
            style={{ hyphens: "auto", wordBreak: "break-word" }}
          >
            Pelajari tentang manfaat yang kami tawarkan kepada mitra kami. Mulai
            dari akses ke pangsa pasar yang lebih luas hingga berbagi
            pengetahuan industri yang berharga.
          </div>
          <div className="mt-16 grid gap-6 md:grid-cols-3 max-md:mt-8">
            <div className="flex flex-col text-white rounded-lg bg-[#1c75ac] shadow-lg p-6">
              <div className="text-xl font-semibold mb-3">
                Memperluas jaringan kemitraan
              </div>
              <div className="text-md leading-6 flex-grow text-justify">
                OKOCE telah bekerja sama dengan mitra, komunitas, hingga
                institusi dengan latar belakang yang beragam di Indonesia. Kita
                bisa menjalin hubungan baru dan mempererat jejaring dengan
                cakupan yang lebih luas.
              </div>
            </div>
            <div className="flex flex-col text-white rounded-lg bg-[#1c75ac] shadow-lg p-6">
              <div className="text-xl font-semibold mb-3">
                Mengembangkan pertumbuhan bisnis
              </div>
              <div className="text-md leading-6 flex-grow text-justify">
                Melalui kerja sama dengan GandengTangan, kita bisa membangun
                bisnis yang lebih baik dan berkelanjutan secara ekonomi maupun
                bisnis. Sehingga kedua belah pihak bisa saling menguntungkan
                satu sama lain.
              </div>
            </div>
            <div className="flex flex-col text-white rounded-lg bg-[#1c75ac] shadow-lg p-6">
              <div className="text-xl font-semibold mb-3">
                Meningkatkan inklusivitas keuangan bagi UMKM di Indonesia
              </div>
              <div className="text-md leading-6 flex-grow text-justify">
                Sejalan dengan visi dan misi GandengTangan, perusahaanmu bisa
                ikut terlibat dalam meningkatkan inklusivitas keuangan bagi
                UMKM, yang belum terlayani di perkotaan maupun pelosok yang ada
                di Indonesia.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-6 py-8 md:py-12 bg-gray-50">
          <>
            {mitraData.map((mitra) => (
              <div
                key={mitra?.id || Math.random()}
                className="flex flex-col items-center mx-auto w-full md:max-w-4xl lg:max-w-7xl"
              >
                <div className="text-center pt-8 md:pt-10 lg:pt-20 mb-10">
                  <p className="font-bold text-3xl text-[#1c75ac] mb-4 rounded-full border-4 border-[#1c75ac] w-24 h-24 flex items-center justify-center mx-auto hover:scale-105 transition-all">
                    {mitra.total || "0"}
                  </p>
                  <h2 className="text-[#1c75ac] font-poppins font-bold text-3xl md:text-4xl">
                    Total Kerja Sama Mitra {mitra.title || "No Category Name"}
                  </h2>
                </div>
                <div className="w-full mx-auto h-auto overflow-hidden pb-4">
                  <div className="flex flex-wrap justify-center gap-y-8 gap-x-6">
                    {Array.isArray(mitra.image) && mitra.image.length > 0 ? (
                      mitra.image.map((image, index) => (
                        <div
                          key={index}
                          className="w-32 h-32 lg:w-44 lg:h-44 overflow-hidden rounded-3xl flex justify-center items-center shadow-md bg-white hover:scale-105 transition-all"
                        >
                          <img
                            src={`https://cms.okoce.net/storage/${image}`}
                            alt={mitra.title || "No Name"}
                            className="max-w-28 max-h-28 object-cover"
                          />
                        </div>
                      ))
                    ) : (
                      <p className="text-center text-gray-500">
                        No images available
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </>
      </div>
      <div className="flex flex-col px-64 py-20 text-lg leading-5 text-gray-800 bg-gray-50 max-md:px-5">
        <h1 className="mt-7 text-2xl lg:text-4xl font-bold max-md:max-w-full text-center">
          Mari Berkolaborasi Bersama OK OCE Indonesia
        </h1>
        <p className="mt-2 lg:mt-4 text-base lg:text-lg leading-7 max-md:mt-10 max-md:max-w-full text-center mb-10">
          Jika Anda tertarik untuk menjajaki kemitraan dengan kami, jangan ragu
          untuk menghubungi kami. Kami siap untuk mendiskusikan berbagai peluang
          yang bisa kita ciptakan bersama
        </p>
        <MitraForm />
      </div>
      <FloatingMenu />
    </>
  );
};
export default MitraList;
